<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template #activator="{ on }">
      <slot :on="on" />
    </template>
    <task-form
      :task="task"
      :specs="specs"
      :categories="categories"
      @update="update"
      @valid="isValid"
    >
      <template #title>
        <v-icon small>
          <slot name="icon" />
        </v-icon><span class="pl-2">Create Schedule Task</span>
        <v-spacer />
        <v-btn
          icon
          :disabled="loading"
          @click="dialog = false"
        >
          <v-icon color="gray">
            fas fa-times
          </v-icon>
        </v-btn>
      </template>
      <template #actions>
        <v-btn
          color="primary"
          :disabled="!valid"
          :loading="loading"
          @click="saveTask"
        >
          Create
        </v-btn>
      </template>
    </task-form>
  </v-dialog>
</template>

<script>
import { scheduler, user } from '@rhitics/core'
import { cloneDeep } from 'lodash'
import TaskForm from './TaskForm.vue'

export default {
  name: 'TaskCreateDialog',

  components: { TaskForm },

  props: {
    task: {
      type: Object,
      default: undefined
    },
    specs: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      loading: false,
      dialog: false,
      form: {
        ownerId: NaN,
        name: '',
        specId: -1,
        spec: {
          id: NaN,
          name: '',
          categoryId: NaN,
          description: '',
          method: 'GET',
          endpoint: '',
          schema: {},
          headersSchema: {}
        },
        payload: {},
        headers: {},
        timezone: '',
        cron: '',
        active: false,
        useJob: false,
      },
      errorMsg: '',
      valid: false
    }
  },

  watch: {
    dialog() {
      if (this.task) this.form = cloneDeep(this.task)
    }
  },

  methods: {
    update(form) {
      this.form = form
    },
    isValid(vaild) {
      this.valid = vaild
    },
    async saveTask() {
      this.loading = true
      const postPayload = await this.getPostPayload(this.form)
      try {
        await scheduler.task.create(postPayload)
        this.$emit('update')
      } catch (error) {
        console.error(error.response)
        this.errorMsg = error.response?.data?.message
      }
      this.loading = false
      this.dialog = false
    },
    async getPostPayload(form) {
      let postData = cloneDeep(form)
      const user = await this.$auth.user
      postData.timezone = user.timezone
      postData.ownerId = user.id
      postData.payload = JSON.stringify(postData.payload)
      postData.headers = JSON.stringify(postData.headers)
      delete postData.updatedAt
      delete postData.createdAt
      delete postData.spec
      delete postData.owner
      return postData
    }
  }
}
</script>
